// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__container-fWd7oi","chartContainer":"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__chartContainer-vneKFT","emptyChartContainer":"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__emptyChartContainer-Heevri","childContainer":"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__childContainer-dcw9mL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__container-fWd7oi\",\"chartContainer\":\"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__chartContainer-vneKFT\",\"emptyChartContainer\":\"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__emptyChartContainer-Heevri\",\"childContainer\":\"src-domain-components-logical-device-hardware-status-charts-logicalDeviceHardwareStatusCharts-module__childContainer-dcw9mL\"}";
        // 1792611263641
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  